interface EditorLetterProps {
  editorName: string;
  editorTitle: string;
  editorImage: string;
  message: string;
}

export const EditorLetter = ({ editorName, editorTitle, editorImage, message }: EditorLetterProps) => {
  return (
    <div className="border-t border-b border-border/40 bg-muted/20 py-12 mb-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px flex-1 bg-border" />
            <h2 className="text-sm uppercase tracking-widest text-muted-foreground font-semibold">
              Letter from the Editor
            </h2>
            <div className="h-px flex-1 bg-border" />
          </div>

          <div className="grid md:grid-cols-[200px_1fr] gap-8 items-start">
            {/* Editor Photo */}
            <div className="mx-auto md:mx-0">
              <img 
                src={editorImage} 
                alt={editorName}
                className="w-40 h-40 md:w-48 md:h-48 rounded-full object-cover border-4 border-background shadow-lg"
              />
            </div>

            {/* Letter Content */}
            <div>
              <p className="text-lg leading-relaxed text-foreground mb-6 font-serif italic">
                {message}
              </p>
              
              <div className="border-t border-border/40 pt-4">
                <p className="font-semibold text-foreground">{editorName}</p>
                <p className="text-sm text-muted-foreground uppercase tracking-wide">{editorTitle}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
